export const environment = {
  "production": false,
  "appName": "@ec/fleet-dashboard-v2",
  "appVersion": "1.0.27",
  "apiUrl": "https://public.cicd.cicd.elevationcurb.com/api/v1",
  "webAppUrl": "https://webapp.cicd.cicd.elevationcurb.com",
  "hubAppUrl": "https://hub.cicd.cicd.elevationcurb.com",
  "installationApiUrl": "https://install.cicd.cicd.elevationcurb.com/api",
  "liveDataServiceUrl": "wss://lds.cicd.cicd.elevationcurb.com",
  "timezoneApiKey": "AIzaSyD3NiA0YUwPfnOPGP5fyWkWdNtO5LIlQlU",
  "auth0": {
    "domain": "cicd-curbenergy.us.auth0.com",
    "clientId": "nMKkkej79ZCbhCUPC8MGCAUdvJ0GFneJ",
    "redirectUri": window.location.origin,
    "audience": "public.energycurb.com",
    "responseType": "token id_token",
    "scope": "openid profile email",
    "connection": "users"
  }
};
